<template>
	<div>
		<el-dialog
		  	title="超时登录"
		  	:show-close="false"
		  	:visible.sync="showDialog"
		  	custom-class="login-dialog">
			<div class="login-form rela">
				<div class="ding-code-login abs">
					<i class="iconfont icon-qr-code cmain cursor code-con" @click="getDingQRCodeUrl"></i>
					<span class="code-hover abs"></span>
				</div>
				<span class="code-info ft12 abs">
					钉钉扫码登录更安全
					<span class="code-sj"></span>
					<span class="code-sj-inner"></span>
				</span>
				<el-form :model="loginForm" :rules="rules" ref="loginForm">
					<el-form-item prop="username">
						<el-input placeholder="用户名" v-model="loginForm.username" @blur="judgeNeedCode"></el-input>
					</el-form-item>
					<el-form-item prop="userpwd">
						<el-input placeholder="密码" type="password" v-model="loginForm.userpwd" @keyup.enter.native="login"></el-input>
					</el-form-item>
					<el-form-item prop="ding_code" :rules="{required:true,message:'请输入钉钉口令'}" v-if="!loginForm.hasDingCode">
						<el-row>
							<el-col :span="16">
								<el-input placeholder="请输入钉钉口令" v-model="loginForm.ding_code" prefix-icon="iconfont icon-quanxianyuechi-xianxing"></el-input>
							</el-col>
							<el-col :span="8" class="ftr">
								<el-button size="small" v-if="!loginForm.showTime" @click="getDingCode" :disabled="loginForm.username === ''" title="请先输入用户名">获取口令</el-button>
								<span class="cmain ft12" v-else>{{ loginForm.time }}s后重新获取</span>
							</el-col>
						</el-row>
					</el-form-item>
				</el-form>
			</div>
			<div class="ftr">
				<el-link type="primary" @click="toReset">忘记密码</el-link>
			</div>
		  	<span slot="footer" class="dialog-footer">
		    	<!-- <el-button @click="cancel">取 消</el-button> -->
		    	<el-button type="primary" @click="login">确 定</el-button>
		  	</span>
		</el-dialog>
	</div>
</template>

<script>
	import jwtdecode from 'jwt-decode'
	import {commonApi} from '@/api/common'
	export default{
		data(){
			return {
				rules:{
        			username:[
          				{required:true,message:'请输入用户名',trigger:'blur'}
        			],
        			userpwd:[
          				{required:true,message:'请输入密码',trigger:'blur'}
        			]
      			},
			    loginForm:{
			        username:'',
			        userpwd:'',
					orgId:100,
					ding_code:'',
					hasDingCode:true,//是否有钉钉验证码
					showTime:false,//是否显示计时器
					time:60,
					timeObj:null,//计时器
			    },
			}
		},
		mounted(){
			if(window.location.href.indexOf('login')>-1){
				this.$store.commit('changeLoginDialog',false)
			}
		},
		methods:{
			//清除相关数据
			clearData() {
				this.loginForm.showTime = false
				this.loginForm.time = 60
			},
			//判断是否需要钉钉口令
			judgeNeedCode() {
				this.loginForm.username = this.loginForm.username.trim()
				if(this.loginForm.username === '') {
					return false;
				}
				this.$EpetJs.Common.ajax('get',commonApi.judgeNeedCodeUrl,{
					user_name: this.loginForm.username
				}).then(res => {
					if(res) {
						this.loginForm.hasDingCode = res.data.data;
					}
				})
			},
			//获取钉钉验证码
			getDingCode() {
				this.$EpetJs.Common.ajax('get',commonApi.getDingCodeUrl,{
					user_name:this.loginForm.username
				}).then(res => {
					if(res) {
						this.loginForm.showTime = true
						this.loginForm.timeObj = setInterval(()=>{
							this.loginForm.time--
							if(this.loginForm.time == 0) {
								this.loginForm.showTime = false
								this.clearTime()
							}
						},1000)
					}
				})
			},
			//清除定时器
			clearTime() {
				clearInterval(this.loginForm.timeObj)
			},
			login(){
      			this.$refs['loginForm'].validate((valid) => {
        			if(valid){
            			this.$store.dispatch('getRoles',{name:this.loginForm.username.trim(),password:this.loginForm.userpwd,ding_code:this.loginForm.ding_code,ac_type:2,org_id:this.loginForm.orgId,platform:this.$store.state.platformName}).then((res) =>{//获取用户权限
             				if(res.status_code != 200){
                				this.$message({
	                  				message: res.message,
	                  				type: 'error'
								});
								//钉钉口令失效
                				if(res.status_code == '103106') {
                					this.loginForm.hasDingCode = false
                				}
                				return
							}
							//密码通过，存储token等信息，跳转首页
							if(res.data.password_is_need_change.pass) {
								var userId = jwtdecode(res.data.token).user.uid
								var acId = jwtdecode(res.data.token).user.acId
								var expire = jwtdecode(res.data.token).exp
								this.$store.commit('changeLoginState',{isLogin:true})
								this.$store.commit('saveUser',{userName:this.loginForm.username,userId:userId,acId: acId})
								this.$store.commit('saveToken',{token:res.data.token,expire:expire})
								this.cancel()
							}else{
								this.$store.commit('changeLoginDialog',false)
								this.$router.push(
									{
										name:'reset_login', 
										params:{
											name:this.loginForm.username,
											password:this.loginForm.userpwd,
											password_is_need_change:res.data.password_is_need_change 
										}
									})
							}	
		          		})
		        	}
      			})
   			},
   			cancel(){
   				this.$store.commit('changeLoginDialog',false)
   				EpetJs.Const.isFreshToken = false
   				// window.location.reload()
			},
			//跳转重置密码页面
			toReset() {
				this.$router.push('/reset')
			},
			// 获取钉钉二维码页面
			getDingQRCodeUrl() {
				this.$EpetJs.Common.ajax('get',commonApi.getDingQRCodeUrl,{
					app_name: this.$store.state.platformName
				}).then(res => {
					if(res) {
						if(res.data.data && res.data.data[0].login_url) {
							this.$store.commit('changeLoginDialog',false)
							window.location = res.data.data[0].login_url
						}
					}
				})
			}
		},
		computed: {
    		showDialog(){
				return this.$store.state.showLoginDialog && this.$route.name != 'login'
    		}
		}
	}
</script>

<style lang="less">
	.login-dialog{
		width:400px !important;
		.login-form {
			padding: 40px 30px 0 30px;
			.ding-code-login {
				right: 0;
				top: -43px;
				.code-con {
					font-size: 80px;
				}
				.code-hover {
					width: 110px;
					height: 100px;
					display: inline-block;
					position: absolute;
					background: #fff;
					transform: rotate(45deg);
					right: 20px;
					top: 48px;
				}
			}
			.code-info {
				right: 90px;
				top: -10px;
				background: #e6f7ff;
				border: 1px solid #91d5ff;
				padding: 3px 5px;
				color: #91d5ff;
				.code-sj {
					display: inline-block;
					height: 0;
					border-top: 5px solid transparent;
					border-bottom: 5px solid transparent;
					border-left: 5px solid #91d5ff;
					z-index: 2;
					position: relative;
					right: -14px;
				}
				.code-sj-inner {
					display: inline-block;
					height: 0;
					border-top: 4px solid transparent;
					border-bottom: 4px solid transparent;
					border-left: 4px solid #e6f7ff;
					z-index: 2;
					position: relative;
					right: -9px;
					top: -1px;
				}
			}
		}
	}
</style>